// client/src/pages/Admin/ProjectManager/components/ProjectStats.tsx
/**
 * PROJECT STATS COMPONENT
 * 
 * Displays statistics cards for projects.
 * 
 * @module ProjectManager/Components/ProjectStats
 */

import React from 'react';
import { Eye, FileText, Download } from 'lucide-react';
import { ProjectStats as ProjectStatsType } from '../types/project.types';
import { ProjectStatusLabels } from '../types/project.types';
import { STATUS_CONFIG } from '../constants/project.constants';

interface ProjectStatsProps {
    stats: ProjectStatsType;
    totalViews: number;
    totalDownloads: number;
}

export const ProjectStats: React.FC<ProjectStatsProps> = ({
    stats,
    totalViews,
    totalDownloads
}) => {
    const statCards = [
        {
            label: 'Total Projects',
            value: stats.all,
            icon: FileText,
            color: '#3B82F6',
            bgColor: '#EFF6FF'
        },
        {
            label: ProjectStatusLabels.published,
            value: stats.published,
            icon: STATUS_CONFIG.published.icon,
            color: '#10B981',
            bgColor: '#ECFDF5'
        },
        {
            label: 'Total Views',
            value: totalViews,
            icon: Eye,
            color: '#8B5CF6',
            bgColor: '#F5F3FF'
        },
        {
            label: 'Total Downloads',
            value: totalDownloads,
            icon: Download,
            color: '#F59E0B',
            bgColor: '#FFFBEB'
        }
    ];

    return (
        <div className="stats-grid">
            {statCards.map((stat, index) => {
                const Icon = stat.icon;

                return (
                    <div
                        key={index}
                        className="stat-card"
                        style={{ borderLeftColor: stat.color }}
                    >
                        <div className="stat-card-icon" style={{ backgroundColor: stat.bgColor }}>
                            <Icon size={18} aria-hidden="true" />
                        </div>
                        <div className="stat-card-content">
                            <span className="stat-card-label">{stat.label}</span>
                            <span className="stat-card-value">{stat.value}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};